import { HttpClient } from "@angular/common/http";
import { inject, NgModule } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { Icurriculum } from "../../../models/icurriculum";
import { AlertMessageService } from "../alert-msg/message.service";
import { catchError, of, tap } from "rxjs";
NgModule({
  providers: [AlertMessageService],
});
export const curriculumResolver: ResolveFn<Icurriculum | undefined> = (route, state) => {
  const http = inject(HttpClient);
  const _alertMessageService = inject(AlertMessageService);
  const url = http.get<Icurriculum>(`${environment.apiUrl}api/website/curriclums/filter`).pipe(
    catchError((err) => {
      _alertMessageService.addMsg(err?.error?.msg || "Error loading curriculum data");
      window.location.reload();
      return of(undefined);
    }),
  );
  return url;
};
